// 导入vue
import Vue from "vue";
// 引入vuex
import Vuex from "vuex";
// 引入持久化插件
import createPersistedState from "vuex-persistedstate";
import Login from "./login";
import Chat from "./chat";
import Emedia from "./emedia";
import { noArr } from "@/components/MessageManage/components/methods/computed";
let timer = null;

// 挂载vuex
Vue.use(Vuex);

// 定义状态
const state = {

    // 表示登录token
    token: "",
    // 表示判断token是否已经失效  如果没有值 表示已经失效 如果有值表示存在
    tokenFlag: "",
    // 表示刷新token
    refreshToken: "",
    // 表示header导航
    headerNav: "homePage",
    // 表示个人中心导航
    personalCenterNav: "myInfo",
    // 表示完善信息三步走
    skipSwitch: "1",
    // 表示用户名称
    userName: "",
    // 表示头像路径
    portraitPath: "",
    // 求职意向动态id (修改基本信息 以及求职意向)
    wantJobActionId: "",
    // 表示简历完整度(基本信息以及求职意向一定会有信息)
    notesRate: 2,
    // 添加经历
    addExp: "",
    // 表示简历定位
    notesPos: "",
    // 登录check验证(uuid&关键字组成)
    loginCheck: "",
    // 我的简历基本信息监听
    myInfoBaseInfo: "",
    // 表示双选会导航
    doubleNav: null,
    // 记录群聊翻页是否还有下一页
    groupNextPage: [],
    // 记得单聊翻页是否还有下一页
    singleNextPage: [],
    // 表示更多消息加载状态
    moreMsgLoadingStatus: false,
    // 表示页面更新动态通知 $1_$2_$3 $1 页面名称 $2 uuid $3表示传递参数
    page_update_notice: "",
    // 记录浏览页面的次数(数组)
    browseCount:0,
    // 完善信息验证(uuid&关键字组成)
    perfectCheck: "",
};

// getter 方法
const getters = {

    // token
    token: state => state.token,
    // tokenflag
    tokenFlag: state => state.tokenFlag,
    // 刷新token
    refreshToken: state => state.refreshToken,
    // 表示简历完整度
    notesRate: state => state.notesRate,
    // 表示双选会导航
    doubleNav: state => state.doubleNav,
    // 群聊是否有下一次
    groupNextPage: state => state.groupNextPage,
    // 单聊是否有下一页
    singleNextPage: state => state.singleNextPage,
    // 更多消息加载状态
    moreMsgLoadingStatus: state => state.moreMsgLoadingStatus,
    // 表示页面更新通知
    page_update_notice: state => state.page_update_notice,
    // 表示浏览页面的次数
    browseCount:state => state.browseCount,
};

// 定义mutations
const mutations = {

    /**
     * @author lihh
     * @description 设置token
     */
    _token(state, token = "") {
        state.token = token;
    },

    /**
     * @author lihh
     * @description 表示token是否已经失效
     */
    _tokenFlag(state, tokenFlag = "") {
        state.tokenFlag = tokenFlag;
    },

    /**
     * @author lihh
     * @description 设置刷新token
     */
    _refreshToken(state, refreshToken = "") {
        state.refreshToken = refreshToken;
    },

    /**
     * @author lihh
     * @description 设置头部导航
     */
    _headerNav(state, headerNav = "") {
        state.headerNav = headerNav;
    },

    /**
     * @author lihh
     * @description 设置个人中心导航
     */
    _personalCenterNav(state, personalCenterNav = "") {
        state.personalCenterNav = personalCenterNav;
    },

    /**
     * @author lihh
     * @description 表示完善信息三步走
     */
    _skipSwitch(state, skipSwitch = "") {
        state.skipSwitch = skipSwitch;
    },

    /**
     * @author lihh
     * @description 表示用户名称
     */
    _userName(state, userName = "") {
        state.userName = userName;
    },

    /**
     * @author lihh
     * @description 表示头像路径
     */
    _portraitPath(state, portraitPath = "") {
        state.portraitPath = portraitPath;
    },

    /**
     * @author lihh
     * @description 表示求职意向动态id
     */
    _wantJobActionId(state, wantJobActionId = "") {
        state.wantJobActionId = wantJobActionId;
    },

    /**
     * @author lihh
     * @description 表示简历完整度
     */
    _notesRate(state, notesRate = 0) {
        state.notesRate = notesRate;
    },

    /**
     * @author lihh
     * @description 表示添加经历
     */
    _addExp(state, addExp = "") {
        state.addExp = addExp;
    },

    /**
     * @author lihh
     * @description 登录验证
     */
    _loginCheck(state, loginCheck = "") {
        state.loginCheck = loginCheck;
    },

    _perfectCheck(state,perfectCheck ="") {
      state.perfectCheck = perfectCheck;
    },

    /**
     * @author lihh
     * @description 我的简历基本信息监听
     */
    _myInfoBaseInfo(state, myInfoBaseInfo = "") {
        state.myInfoBaseInfo = myInfoBaseInfo;
    },

    /**
     * @author lihh
     * @description 表示双选会导航
     */
    _doubleNav(state, doubleNav = {}) {
        state.doubleNav = doubleNav;
    },

    /**
     * @author lihh
     * @description 表示简历定位
     */
    _notesPos(state, notesPos = {}) {
        state.notesPos = notesPos;
    },

    /**
     * @author lihh
     * @description 修改单聊/群聊中下一页状态
     */
    updateNextPageStatus(state, payload) {

        /* 解构数据 */
        const { type, name, nextPage = true } = payload;
        /* 判断缓存中是否有对象  从给每个对象赋值 */
        const fieldName = `${ type }NextPage`,
            singlePageInfo = state[fieldName] || [],
            localIndex = singlePageInfo.findIndex(item => item.name === name);
        /* 如果分页不存在 直接添加 */
        if ( localIndex === - 1 ) {
            state[fieldName].push({ name, nextPage });

            return;
        }

        /* 如果存在的话，删除后重新添加 */
        state[fieldName].splice(localIndex, 1, { name, nextPage });
    },

    /**
     * @author lihh
     * @description 编辑更多消息加载状态
     * @param state 表示store中的数据
     * @param payload 表示传递数据 initVal -> true 表示用来初期化
     */
    editMoreMsgLoadingStatus(state, payload = {}) {
        const { initVal = true } = payload;
        if ( initVal ) return;
        state.moreMsgLoadingStatus = !state.moreMsgLoadingStatus;
        /* 容错意外处理 */
        if ( state.moreMsgLoadingStatus ) {
            timer = setTimeout(() => {
                state.moreMsgLoadingStatus = false;
                clearTimeout(timer);
                timer = null;
            }, 2000);

            return false;
        }
        if ( timer && !state.moreMsgLoadingStatus ) {
            clearTimeout(timer);
            timer = null;
        }
    },

    /**
     * @author lihh
     * @description 群聊或是单聊 排序
     * @param {*} state
     * @param {*} payload type 表示类型 callback执行的回调
     */
    groupOrSingleFristSortStu(state, payload) {
        /* 进行数据解构 */
        const { options: { data: targetData = [], key: keyName, callback: succCallback } } = payload;
        payload = payload["type"];

        /**
         * 排序思路：
         *      1. 进行数据扁平化 利用Array.sort进行排序
         *      2. 将置顶的数据时间格式都是MAX_SAFE_INTEGER
         *      3. 有时间的填入真实的时间
         *      4. 没有消息记录 || 没有时间的 都是1
         *      5. 用时间为轴线进行排序
         */
        const queryHistroyMsg = (id, type) => {
            /* 获取消息 判断是否有消息 */
            const msgList = state.chat.msgListStu[type === "singleChat" ? "contact" : "group"];
            if ( !msgList[id] ) return { time: 1 };

            /* 获取最后一条数据 */
            let i = msgList[id].length - 1,
                target = msgList[id];
            for ( ; i >= 0; i -- ) {
                if ( target[i]["time"] && !noArr.includes(target[i]["langType"]) ) return { time: + target[i]["time"] };
            }
            return { time: 1 };
        };
        const result = [],
            topResult = [];
        /* 单聊群聊 进行合并操作 */
        let i = 0,
            item = {},
            index = - 1,
            isTop = 0,
            len = targetData.length;
        for ( ; i < len; i ++ ) {
            let obj = {};
            item = targetData[i];
            obj["name"] = item[keyName];
            isTop = item["isTop"];
            obj["time"] = queryHistroyMsg(obj["name"], payload, isTop)["time"];
            obj["isTop"] = isTop;
            (+ isTop === 1 ? topResult : result).push(obj);
        }

        if ( result.length <= 0 ) return;
        /* 进行排序 */
        const sortAfter = result.sort((a, b) => b.time - a.time).map(item => item["name"]),
            sortAfterTop = topResult.sort((a, b) => b.time - a.time).map(item => item["name"]);
        const newUserList = [];

        (sortAfterTop.concat(sortAfter)).forEach(item => {
            index = targetData.findIndex(item1 => item1[keyName] === item);
            newUserList.push(...targetData.splice(index, 1));
        });
        succCallback && succCallback(newUserList);
    },

     /**
     * @description 表示页面更新通知
     * @param {*} state
     * @param {*} payload
     */
      pageUpdateNotice(state, payload) {
        state.page_update_notice = payload;
    },

    // 表示浏览页面的次数
    computeBrowseCount(state) {
      // if (state.browseCount.includes(name)) return true
      state.browseCount++;
     },
    // 将浏览页面的次数置为0
    clearBrowseCount(state) {
      state.browseCount = 0
    }

};

// 定义action
const actions = {

  /**
   * @author lvcx
   * @description 设置浏览页面的次数
   */
   computeBrowseCount(context,payload) {
    if (!Reflect.has(payload, "name")) return
    const {name} = payload
    context.commit("computeBrowseCount", name);
  },

    /**
     * @author lihh
     * @description 设置token
     */
    _token(context, token = "") {
        context.commit("_token", token);
        context.commit("_tokenFlag", token);
    },

    /**
     * @author lihh
     * @description 设置token判断
     */
    _tokenFlag(context, token = "") {
        context.commit("_tokenFlag", token);
    },

    /**
     * @author lihh
     * @description 设置刷新token
     */
    _refreshToken(context, refreshToken = "") {
        context.commit("_refreshToken", refreshToken);
    },

    /**
     * @author lihh
     * @description 设置头部导航
     */
    _personalCenterNav(context, personalCenterNav = "") {
        context.commit("_personalCenterNav", personalCenterNav);
    },

    /**
     * @author lihh
     * @description 设置个人中心导航
     */
    _headerNav(context, headerNav = "") {
        context.commit("_headerNav", headerNav);
    },

    /**
     * @author lihh
     * @description 设置完善信息三步走
     */
    _skipSwitch(context, skipSwitch = "") {
        context.commit("_skipSwitch", skipSwitch);
    },

    /**
     * @author lihh
     * @description 用户名称
     */
    _userName(context, userName = "") {
        context.commit("_userName", userName);
    },

    /**
     * @author lihh
     * @description 头像路径
     */
    _portraitPath(context, portraitPath = "") {
        context.commit("_portraitPath", portraitPath);
    },

    /**
     * @author lihh
     * @description 求职意向动态id
     */
    _wantJobActionId(context, wantJobActionId = "") {
        context.commit("_wantJobActionId", wantJobActionId);
    },

    /**
     * @author lihh
     * @description 表示简历完整度
     */
    _notesRate(context, notesRate = 0) {
        context.commit("_notesRate", notesRate);
    },

    /**
     * @author lihh
     * @description 添加经历
     */
    _addExp(context, addExp = "") {
        context.commit("_addExp", addExp);
    },

    /**
     * @author lihh
     * @description 登录验证
     */
    _loginCheck(context, loginCheck = "") {
        context.commit("_loginCheck", loginCheck);
    },

    /**
     * @author lihh
     * @description 完善信息验证
     */
     _perfectCheck(context, perfectCheck = "") {
      context.commit("_perfectCheck", perfectCheck);
  },

    /**
     * @author lihh
     * @description 我的简历 基本信息监听
     */
    _myInfoBaseInfo(context, myInfoBaseInfo = "") {
        context.commit("_myInfoBaseInfo", myInfoBaseInfo);
    },

    /**
     * @author lihh
     * @description 表示双选会导航
     */
    _doubleNav(context, doubleNav = {}) {
        context.commit("_doubleNav", doubleNav);
    },

    /**
     * @author lihh
     * @description 表示简历定位
     */
    _notesPos(context, notesPos = {}) {
        context.commit("_notesPos", notesPos);
    },
    /**
     * @description 群聊或是单聊 排序 求职者端
     * @param {*} state
     * @param {*} payload
     */
    groupOrSingleFristSortStu({ commit }, payload) {
        commit("groupOrSingleFristSortStu", payload);
    },

    /**
     * @author lihh
     * @description 表示页面更新通知
     * @param {*} context
     * @param {*} payload 传递参数
     */
    pageUpdateNotice(context, payload) {
        /* 解构数据 重新拼接数据 */
        const { $1, $3 } = payload;
        let val = `${ $1 }###${ + new Date() }`;
        if ( $3 ) val += ("###" + $3);
        context.commit("pageUpdateNotice", val);
    },

    /**
     * @author lihh
     * @description 修改下一页状态
     * @param {*} context 上下文
     * @param {*} payload 传递消息
     *              type表示群聊/单聊 name 群id/用户id nextPage true 有 反之没有
     */
    updateNextPageStatus(context, payload) {

        /* 内容限制 */
        const keys = Object.keys(payload);
        if ( !keys.includes("type") || !keys.includes("name") )
            throw new Error("属性[type, name]必须存在");

        /* 提交事件 */
        context.commit("updateNextPageStatus", payload);
    }
};

// 导出文件
export default new Vuex.Store({
    plugins: [ createPersistedState() ],
    // 表示状态
    state,
    getters,
    mutations,
    actions,
    modules: {
        login: Login,
        chat: Chat,
        emedia: Emedia,
    },
});



// WEBPACK FOOTER //
// ./src/store/index.js